export default function setSearchProvinceAction(searchProvince) {
    return {
        type: 'SET_SEARCH_PROVINCE',
        payload: searchProvince
    }
}